/* lua.js generated code 0.3.0 */

/* The MIT License (MIT)
Copyright (c) 2012 Toby Jennings

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and 
associated documentation files (the "Software"), to deal in the Software without restriction, 
including without limitation the rights to use, copy, modify, merge, publish, distribute, 
sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is 
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial
portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT 
NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND 
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, 
DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
-- */
var M = table()
math.randomseed(os.time())
math.random()
function num2bs(num) {
    var _floor = Math.floor
    var result = ""
    if ((num === 0)) {
        return "0"
    }
    while ((num > 0)) {
        result = num % 2 + result
        num = _floor(num * 0.5)
    }
    return result
}
function bs2num(num) {
    var _sub = string.sub
    var [index, result] = [0, 0]
    if ((num === "0")) {
        return 0
    }
    var $var8 = $len(num)
    for (var p = $var8; p >= 1; p += -1) {
        var this_val = _sub(num, p, p)
        if (this_val === "1") {
            result = result + (2 ^ index)
        }
        index = index + 1
    }
    return result
}
function padbits(num, bits) {
    if ($len(num) === bits) {
        return num
    }
    if ($len(num) > bits) {
        cc.log("too many bits")
    }
    var pad = bits - $len(num)
    var $limit14 = pad
    for (var i = 1; i <= $limit14; i += 1) {
        num = "0" + num
    }
    return num
}
function getUUID() {
    var _rnd = math.random
    var _fmt = string.format
    _rnd()
    var time_low_a = _rnd(0, 65535)
    var time_low_b = _rnd(0, 65535)
    var time_mid = _rnd(0, 65535)
    var time_hi = _rnd(0, 4095)
    time_hi = padbits(num2bs(time_hi), 12)
    var time_hi_and_version = bs2num("0100" + time_hi)
    var clock_seq_hi_res = _rnd(0, 63)
    clock_seq_hi_res = padbits(num2bs(clock_seq_hi_res), 6)
    clock_seq_hi_res = "10" + clock_seq_hi_res
    var clock_seq_low = _rnd(0, 255)
    clock_seq_low = padbits(num2bs(clock_seq_low), 8)
    var clock_seq = bs2num(clock_seq_hi_res + clock_seq_low)
    var node = table()
    for (var i = 1; i <= 6; i += 1) {
        node[i] = _rnd(0, 255)
    }
    var guid = ""
    guid = guid + padbits(_fmt("%X", time_low_a), 4)
    guid = guid + padbits(_fmt("%X", time_low_b), 4) + "-"
    guid = guid + padbits(_fmt("%X", time_mid), 4) + "-"
    guid = guid + padbits(_fmt("%X", time_hi_and_version), 4) + "-"
    guid = guid + padbits(_fmt("%X", clock_seq), 4) + "-"
    for (var i = 1; i <= 6; i += 1) {
        guid = guid + padbits(_fmt("%X", node[i]), 2)
    }
    return guid
}
M.getUUID = getUUID
module.exports = M
